import React, { ReactElement } from "react";
import { gql, MutationFunction, useMutation } from "@apollo/client";
import { CountClickThroughMutationMutation, CountClickThroughMutationMutationVariables } from "../../../schemaTypes";

export const countClickThroughMutation = gql`
  mutation CountClickThroughMutation(
    $offerId: String!
  ) {
    countClickThrough(
      offerId: $offerId, 
    ){
      errors{
        path
        message
      }
      message
    }
  }
`;

export interface WithCountClickThrough {
  countClickThrough: MutationFunction<
    CountClickThroughMutationMutation,
    CountClickThroughMutationMutationVariables
  >;
}

interface Props {
  children: (data: WithCountClickThrough) => ReactElement | null;
}

export const CountClickThrough: React.FC<Props> = ({ children }) => {
  const [mutate] = useMutation<
    CountClickThroughMutationMutation,
    CountClickThroughMutationMutationVariables
  >(countClickThroughMutation);

  return children({ countClickThrough: mutate });
};